import { Dropdown, Space, Divider, Button, theme } from 'antd'
import UserAvatar from '../../components/Avatar/UserAvatar'
import styles from './DropdownProfile.module.css'

import { useNavigate } from 'react-router-dom'
import { getUser, removeUserSession } from '../../utils/sessionManagement'
function DropdownProfile({ width, height, fontSize }) {
  const history = useNavigate()
  const handleLogOut = () => {
    removeUserSession()
    console.log('handleLogOut')
    history('/login')
  }

  return (
    <Dropdown
      dropdownRender={() => (
        <div className={styles.dropdown_profile}>
          <div className={styles.bloc_center_picture_profile}>
            <UserAvatar
              size="large"
              width={60}
              height={60}
              hasBadge={false}
              fontSize={30}
              userName={getUser() || ''}
            />
            <div className={styles.name_of_user}>{getUser()}</div>
          </div>

          <Divider style={{ margin: '0' }} />

          <div onClick={handleLogOut} className={styles.text}>
            Se déconnecter
          </div>
        </div>
      )}
    >
      <a onClick={(e) => e.preventDefault()}>
        <Space>
          <UserAvatar
            width={width}
            height={height}
            size="large"
            hasBadge={false}
            cursor={'pointer'}
            fontSize={fontSize || 14}
            userName={getUser()}
          />
        </Space>
      </a>
    </Dropdown>
  )
}

export default DropdownProfile
